import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {HomePage} from './home.page';
import {NgxJsonViewerModule} from '../../partials/ngx-json-viewer/ngx-json-viewer.module';

const routes: Routes = [
    {
        path: '',
        component: HomePage
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes), NgxJsonViewerModule],
    exports: [RouterModule],
})
export class HomePageRoutingModule {
}
